import { render } from "./DonneesPersonnelles.vue?vue&type=template&id=3912a6b4"
import script from "./DonneesPersonnelles.vue?vue&type=script&lang=js"
export * from "./DonneesPersonnelles.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/suivi-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__